import { render, staticRenderFns } from "./person-center.html?vue&type=template&id=ba47a818&scoped=true&external"
import script from "./person-center.js?vue&type=script&lang=js&external"
export * from "./person-center.js?vue&type=script&lang=js&external"
import style0 from "./person-center.scss?vue&type=style&index=0&id=ba47a818&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba47a818",
  null
  
)

export default component.exports